// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_30-1";
export var rateTableServiceLevelDropdown = "_30-3";
export var rateTableTypeDropdown = "_30-0";
export var rateTableValueModeDropdown = "_30-2";